module.exports = __webpack_public_path__ + "img/3-4.4f9583f7.jpg";